import { Help, HelpProps } from "~/common/components/Icon";

export type HelpHintProps = HelpProps;

export const HelpHint = ({ sx, ...rest }: HelpHintProps) => {
  return <Help size="small" color="primary.gray600" {...rest} sx={{ cursor: "pointer", ...sx }} />;
};
